import { ITreeviewNhomLopFocusedValue } from "../../../components-data/treeview-nhom-lop/TreeviewNhomLop";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachLopSelectRequest } from "../../../model/request/ke-hoach/IKeHoachLopSelectRequest";
import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { IKeHoachMonChiTietSaveRequest } from "../../../model/request/ke-hoach/IKeHoachMonChiTietSaveRequest";
import { IKeHoachMonCopyRequest } from "../../../model/request/ke-hoach/IKeHoachMonCopyRequest";
import { IKeHoachMonSelectByLopsRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectByLopsRequest";
import { IKeHoachMonSelectByNhomLopRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectByNhomLopRequest";
import { IKeHoachMonUpdateGiaiDoanRequest } from "../../../model/request/ke-hoach/IKeHoachMonUpdateGiaiDoanRequest";
import { IKeHoachLop } from "../../../model/respone/ke-hoach/IKeHoachLop";
import { IKeHoachMonChiTiet } from "../../../model/respone/ke-hoach/IKeHoachMonChiTiet";
import { IKeHoachMonUpdateGiaiDoanRespone } from "../../../model/respone/ke-hoach/IKeHoachMonUpdateGiaiDoanRespone";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { IKeHoachMonCopy, IKeHoachMonGanGiaiDoan } from "../../reducer-model/ke-hoach/IKeHoachMonReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachMonActionsObj = {
    CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewNhomLopFocusedValue,

    KE_HOACH_LOP_LOAD_START: {} as IKeHoachLopSelectRequest,
    KE_HOACH_LOP_LOAD_SUCCESS: {} as IKeHoachLop[],
    KE_HOACH_LOP_LOAD_ERRR: "",

    LOAD_START: {} as IKeHoachMonSelectByLopsRequest,
    LOAD_SUCCESS: {} as IKeHoachMonViewModel[],
    LOAD_ERRR: "",

    // Gộp: 1 API select-nhom-lop-full trả về cả kế hoạch môn + chi tiết phân tiết.
    // Saga put LOAD_SUCCESS + LOAD_CHITIET_SUCCESS (reuse reducer, không thêm state mới).
    LOAD_NHOMLOP_FULL_START: {} as IKeHoachMonSelectByNhomLopRequest,


    DELETE_START: {} as number[],
    DELETE_SUCCESS: {} as number[],
    DELETE_ERRR: "",

    SHOW_ADD_MON_MODAL: 0,
    CLOSE_ADD_MON_MODAL: undefined,

    CHANGE_ADD_MON_SELECTED_IDS: {} as number[],

    ADDING_MONHOC_START: {} as IKeHoachMonAddRequest,
    ADDING_MONHOC_SUCCESS: undefined,
    ADDING_MONHOC_ERRR: "",

    UPDATE_GIAI_DOAN_START: {} as IKeHoachMonUpdateGiaiDoanRequest,
    UPDATE_GIAI_DOAN_SUCCESS: {} as IKeHoachMonUpdateGiaiDoanRespone,
    UPDATE_GIAI_DOAN_ERRR: "",


    LOAD_CHITIET_START: {} as IKeHoachMonSelectByLopsRequest,
    LOAD_CHITIET_SUCCESS: {} as IKeHoachMonChiTiet[],
    LOAD_CHITIET_ERROR: "",

    SAVE_CHITIET_START: {} as IKeHoachMonChiTietSaveRequest,
    SAVE_CHITIET_SUCCESS: {} as IKeHoachMonChiTiet[],
    SAVE_CHITIET_ERROR: "",

    DELETE_CHITIET_START: {} as IIdsRequest,
    DELETE_CHITIET_SUCCESS: {} as number[],
    DELETE_CHITIET_ERROR: "",

    CHANGE_KE_HOACH_MON_SELECTED_IDS: {} as number[],

    UPDATE_GAN_GIAI_DOAN: {} as IKeHoachMonGanGiaiDoan,
    UPDATE_COPY_KEHOACH: {} as IKeHoachMonCopy,

    COPY_START: {} as IKeHoachMonCopyRequest,
    COPY_SUCCESS: undefined,
    COPY_ERROR: "",


};
export const eKeHoachMonActionIds = generateActionTypeIds(
    eKeHoachMonActionsObj,
    "KE_HOACH_MON"
);
export type IKeHoachMonActionTypes = IGenericActionType<
    typeof eKeHoachMonActionsObj,
    "KE_HOACH_MON"
>;
